import css from 'styled-jsx/css';

export const staticStyles = css`
  .LeanPay {
    width: 100%;
    height: 100%;
    background-color: #1976d2;
    color: #fff;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;
    padding: 20px;
    box-sizing: border-box;
    overflow: auto;
  }

  /* Emirates ID Modal */
  .emirates-id-modal {
    display: flex;
    position: fixed;
    z-index: 1000;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    justify-content: center;
    align-items: center;
  }

  .emirates-id-modal-content {
    background-color: #081717;
    border: 2px solid #4caf50;
    border-radius: 10px;
    padding: 30px;
    max-width: 500px;
    width: 90%;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
  }

  .emirates-id-modal-title {
    color: #4caf50;
    font-size: 1.5rem;
    margin-bottom: 20px;
    text-align: center;
  }

  .emirates-id-modal-description {
    color: #fff;
    margin-bottom: 20px;
    text-align: center;
    font-size: 0.95rem;
  }

  .emirates-id-input-group {
    margin-bottom: 20px;
  }

  .emirates-id-input-group label {
    display: block;
    color: #4caf50;
    margin-bottom: 8px;
    font-weight: bold;
  }

  .emirates-id-input-group input {
    width: 100%;
    padding: 10px;
    background-color: rgba(255, 255, 255, 0.1);
    border: 1px solid #4caf50;
    border-radius: 5px;
    color: #fff;
    font-size: 1rem;
  }

  .emirates-id-input-group input:focus {
    outline: none;
    border-color: #45a049;
    box-shadow: 0 0 0 0.2rem rgba(76, 175, 80, 0.25);
  }

  .emirates-id-error {
    color: #dc3545;
    font-size: 0.85rem;
    margin-top: 5px;
  }

  .emirates-id-modal-buttons {
    display: flex;
    justify-content: center;
    gap: 15px;
    margin-top: 25px;
  }

  .btn-confirm {
    padding: 10px 30px;
    border: none;
    border-radius: 5px;
    font-size: 1rem;
    cursor: pointer;
    transition: all 0.3s;
    background-color: #4caf50;
    color: white;
  }

  .btn-confirm:hover:not(:disabled) {
    background-color: #45a049;
  }

  .btn-confirm:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
  }

  /* Result Messages */
  .result-message {
    padding: 10px;
    margin: 10px 0;
    border-radius: 5px;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
  }

  .result-message.success {
    background-color: rgba(76, 175, 80, 0.2);
    border: 1px solid #4caf50;
    color: #4caf50;
  }

  .result-message.error {
    background-color: rgba(220, 53, 69, 0.2);
    border: 1px solid #dc3545;
    color: #dc3545;
  }

  /* Verification Messages */
  .verification-message {
    padding: 10px;
    margin: 10px 0;
    border-radius: 5px;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
  }

  .verification-message.success {
    background-color: rgba(76, 175, 80, 0.2);
    border: 1px solid #4caf50;
    color: #4caf50;
  }

  .verification-message.error {
    background-color: rgba(220, 53, 69, 0.2);
    border: 1px solid #dc3545;
    color: #dc3545;
  }

  /* Bank Selection */
  .bank-selection-container {
    width: 100%;
    max-width: 600px;
    margin: 20px auto;
  }

  .bank-selection-title {
    color: #fac529;
    margin-bottom: 15px;
    font-size: 1.2em;
    font-weight: bold;
    text-align: center;
  }

  .bank-selection-description {
    color: #e0e0e0;
    margin-bottom: 20px;
    font-size: 0.95em;
    text-align: center;
  }

  .bank-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .bank-item {
    background-color: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(76, 175, 80, 0.5);
    border-radius: 8px;
    padding: 15px;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .bank-item:hover {
    background-color: rgba(76, 175, 80, 0.2);
    border-color: #4caf50;
  }

  .bank-item.selected {
    background-color: rgba(76, 175, 80, 0.3);
    border-color: #4caf50;
    border-width: 2px;
  }

  .bank-info {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 15px;
  }

  .bank-logo {
    width: 40px;
    height: 40px;
    border-radius: 4px;
  }

  .bank-name {
    font-weight: bold;
    color: #fff;
    font-size: 1.1em;
  }

  .bank-country {
    color: #aaa;
    font-size: 0.9em;
    margin-left: auto;
  }

  .bank-connection-process {
    color: #aaaaaa;
    font-size: 0.8em;
    text-align: center;
    margin-top: 15px;
    margin-bottom: 15px;
    padding: 10px;
    background-color: rgba(255, 193, 7, 0.1);
    border-radius: 5px;
    border: 1px solid rgba(255, 193, 7, 0.3);
  }

  /* Payment Sources */
  .payment-sources-container {
    width: 100%;
    max-width: 600px;
    margin: 20px auto;
  }

  .payment-sources-title {
    color: #4caf50;
    margin-bottom: 15px;
    font-size: 1.2em;
    font-weight: bold;
    text-align: center;
  }

  .payment-sources-description {
    color: #e0e0e0;
    margin-bottom: 20px;
    font-size: 0.95em;
    text-align: center;
  }

  .payment-sources-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .payment-source-item {
    background-color: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(76, 175, 80, 0.5);
    border-radius: 8px;
    padding: 15px;
    cursor: pointer;
    transition: all 0.3s ease;
    text-align: left;
  }

  .payment-source-item:hover {
    background-color: rgba(76, 175, 80, 0.2);
    border-color: #4caf50;
  }

  .payment-source-item.selected {
    background-color: rgba(76, 175, 80, 0.3);
    border-color: #4caf50;
    border-width: 2px;
  }

  .source-bank-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
  }

  .source-bank-identifier {
    font-weight: bold;
    color: #fff;
    font-size: 1.1em;
  }

  .account-number {
    color: #aaa;
    font-family: monospace;
  }

  .status {
    padding: 3px 8px;
    border-radius: 4px;
    font-size: 0.85em;
    font-weight: bold;
  }

  .status.ACTIVE {
    background-color: rgba(76, 175, 80, 0.3);
    color: #4caf50;
  }

  .status.AWAITING_BENEFICIARY_COOL_OFF {
    background-color: rgba(255, 193, 7, 0.3);
    color: #ffc107;
  }

  .status.INACTIVE {
    background-color: rgba(220, 53, 69, 0.3);
    color: #dc3545;
  }

  .cool-off-expiry {
    color: #ffc107;
    font-size: 0.85em;
    margin-top: 8px;
  }

  .delete-source-btn {
    background-color: #dc3545;
    border: none;
    color: white;
    padding: 5px 10px;
    font-size: 0.8em;
    border-radius: 4px;
    cursor: pointer;
    margin-top: 10px;
  }

  .delete-source-btn:hover {
    background-color: #c82333;
  }

  /* Loading */
  .loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
  }

  .spinner {
    border: 4px solid rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    border-top: 4px solid #4caf50;
    width: 30px;
    height: 30px;
    animation: spin 1s linear infinite;
    margin-bottom: 10px;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  /* Buttons */
  .connect-btn,
  .pay-btn {
    padding: 0.75rem 1.25rem;
    font-weight: 700;
    width: 100%;
    max-width: 300px;
    border: 1px solid #4500e2;
    color: #4500e2;
    background-color: #fff;
    border-radius: 4px;
    cursor: pointer;
    margin: 20px auto;
    display: block;
  }

  .connect-btn:hover,
  .pay-btn:hover {
    background-color: #f0f0f0;
  }

  /* Header */
  .leanpay-header {
    margin-bottom: 20px;
    text-align: center;
  }

  .leanpay-title {
    font-size: 1.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    margin: 0;
  }

  .free-badge {
    background-color: #4caf50;
    color: white;
    padding: 2px 8px;
    border-radius: 6px;
    font-size: 0.6em;
    vertical-align: middle;
  }

  /* No items messages */
  .no-banks-message,
  .no-sources-message {
    color: #aaa;
    text-align: center;
    padding: 20px;
  }
`;
